import { mix_matchrequest, mix_match_response } from "../models/baske.model";
import { Product } from "../models/product.model";
import { PageName } from "../helpers/helper.common";

interface IProductPagemodel {
  Name: number;
  selectedProduct: Product;
  selectedVariant: number;
  firstVariantName: string;
  secondVariantName: string;
  firstVariantOptions: string[];
  secondVariantOptions: string[];
  firstSelectedVariant: string;
  secondSelectedVariant: string;
  selectedVariantName: string;
  basketTotal: number;
  basketTotalLessVAT: number;
  basketVATTotal: number;
  hideSecondattr: boolean;
  Isproductshow: boolean;
  matchFound1: boolean;
  matchFound2: boolean;
  message: string;
  modal;
  extraProductModal;
  viewOnly: number;
  tempProductId: number;
  selectedMixAndMatch: mix_match_response[];
  displayedMixAndMatchList: mix_matchrequest[];
  Imageslider: Array<object>;
  upsell_category_id: number;
}
export class ProductPagemodel implements IProductPagemodel {
  constructor() {
    this.Name = PageName.Product;
    this.selectedProduct = null;
    this.firstVariantName = "option 1";
    this.secondVariantName = "option 2";
    this.selectedVariantName = "";
    this.basketTotal = 0;
    this.basketTotalLessVAT = 0;
    this.basketVATTotal = 0;
    this.hideSecondattr = true;
    this.Isproductshow = false;
    this.matchFound1 = false;
    this.matchFound2 = false;
    this.message = "No open orders currently.";
    this.selectedMixAndMatch = [];
    this.displayedMixAndMatchList = [];
    this.upsell_category_id = 0;
    this.productText = "";
    this.productImage = "";
    this.productImageFile = null;
  }
  Name: number;
  selectedProduct: any;
  selectedVariant: number;
  firstVariantName: string;
  secondVariantName: string;
  firstVariantOptions: string[];
  secondVariantOptions: string[];
  firstSelectedVariant: string;
  secondSelectedVariant: string;
  selectedVariantName: string;
  basketTotal: number;
  basketTotalLessVAT: number;
  basketVATTotal: number;
  hideSecondattr: boolean;
  Isproductshow: boolean;
  matchFound1: boolean;
  matchFound2: boolean;
  message: string;
  modal;
  extraProductModal;
  stockLimitModal;
  loginModal;
  loginOptions;
  productInstructionModal;
  regModal;
  productModal;
  updateVariantPopup;
  viewOnly;
  tempProductId: number;
  selectedMixAndMatch: mix_match_response[];
  displayedMixAndMatchList: mix_matchrequest[];
  Imageslider: Array<object>;
  upsell_category_id: number;
  productText;
  productImage;
  productImageFile;
  productImagePath;
  productImageUrl;
}
